const parsePositiveInt = (value, fallback) => {
  const parsed = Number.parseInt(value, 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
};

const DEFAULT_MAX_LINKED_ORGANIZATIONS = 10;

export const appSettings = {
  maxLinkedOrganizations: parsePositiveInt(
    process.env.REACT_APP_MAX_LINKED_ORGANIZATIONS,
    DEFAULT_MAX_LINKED_ORGANIZATIONS
  ),
};

let runtimeMaxLinkedOrganizations = null;

export const setMaxLinkedOrganizations = (value) => {
  runtimeMaxLinkedOrganizations = parsePositiveInt(value, appSettings.maxLinkedOrganizations);
};

export const getMaxLinkedOrganizations = () =>
  runtimeMaxLinkedOrganizations ?? appSettings.maxLinkedOrganizations;

export const getLinkedOrganizationLimitMessage = (
  limit = getMaxLinkedOrganizations()
) =>
  `You can link up to ${limit} organizations. Remove an existing link or contact support to add more.`;
